// src/api/calendarApi.js
import axios from "./index";

class CalendarApi {
  /**
   * Obtiene eventos filtrados por rango de fechas
   * @param {string} startDate - Fecha inicial (ISO format)
   * @param {string} endDate - Fecha final (ISO format)
   */
  static getEvents = (startDate = null, endDate = null) => {
    const params = {
      page_size: 200, // Solicitar hasta 200 eventos por página
    };
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    return axios.get(`/calendar/events/`, { params });
  };

  static getMyEvents = (startDate = null, endDate = null) => {
    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;
    return axios.get(`/calendar/my-events/`, { params });
  };

  static getUpcomingEvents = (limit = 10) => {
    return axios.get(`/calendar/upcoming/`, { params: { limit } });
  };

  static createEvent = (eventData) => {
    console.log("eventData: " + eventData);
    return axios.post(`/calendar/events/`, eventData);
  };

  static updateEvent = (eventId, eventData) => {
    return axios.put(`/calendar/events/${eventId}/`, eventData);
  };

  static deleteEvent = (eventId) => {
    return axios.delete(`/calendar/events/${eventId}/`);
  };

  static addReminder = (eventId, reminderTime) => {
    return axios.post(`/calendar/events/${eventId}/add_reminder/`, {
      reminder_time: reminderTime,
    });
  };

  /**
   * Actualiza solo la fecha/hora de un evento (para drag & drop)
   */
  static updateEventDates = (eventId, startTime, endTime) => {
    return axios.patch(`/calendar/events/${eventId}/`, {
      start_time: startTime,
      end_time: endTime,
    });
  };
}

export default CalendarApi;
